<script>
export default {
  name: 'TimePicker',
    model: {
        prop: 'modelValue', // Custom prop name
        event: 'update:modelValue' // Custom event name
    },
  props: {
      modelValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      times: [],
      optimalHoursText: '8',
      selectedTimes: []
    }
  },
  computed: {
    timeBlocks() {
      // Reorder time blocks: 20-23, 00-03, 16-19, etc
      const blocks = []
      // Last block (20-23)
      blocks.push(this.times.slice(20, 24))
      // First block (00-03)
      // blocks.push(this.times.slice(0, 4))
      // Second to last block (16-19)
      // blocks.push(this.times.slice(0, 20))
      // Add remaining blocks in original order
      for (let i = 0; i < 20; i += 4) {
        blocks.push(this.times.slice(i, i + 4))
      }
      return blocks
    },
    totalHours() {
      return this.selectedTimes.length
    },
    nightHours() {
      return this.selectedTimes.filter(time => {
        const hour = parseInt(time.split(':')[0])
        return hour < 11 || hour >= 20
      }).length
    },
    dayHours() {
      return this.selectedTimes.filter(time => {
        const hour = parseInt(time.split(':')[0])
        return hour >= 11 && hour < 20
      }).length
    },
    sleepDurationStatus() {
      const total = this.totalHours
      if (total >= 7 && total <= 9) return 'optimal'
      if (total > 9) return 'tooMuch'
      if (total >= 5 && total < 7) return 'low'
      return 'critical'
    }
  },
  created() {
    // Generate times from 00:00 to 23:00
    for (let i = 0; i < 24; i++) {
      this.times.push(`${String(i).padStart(2, '0')}:00`)
    }
    // Initialize selected times from prop
    this.selectedTimes = [...this.modelValue]
  },
  watch: {
    modelValue: {
      handler(newValue) {
        this.selectedTimes = [...newValue]
      },
      deep: true
    },
    selectedTimes: {
      handler() {
        this.$emit('update:totalHours', this.totalHours)
      },
      deep: true
    }
  },
  methods: {
    isSelected(time) {
      return this.selectedTimes.includes(time)
    },
    selectTime(time) {
      const index = this.selectedTimes.indexOf(time)
      if (index === -1) {
        // Add time if not selected
        this.selectedTimes.push(time)
      } else {
        // Remove time if already selected
        this.selectedTimes.splice(index, 1)
      }
      // Sort times for consistent order
      this.selectedTimes.sort()
      console.log('Selected times changed:', this.selectedTimes)
      // Emit update to parent
      this.$emit('update:modelValue', [...this.selectedTimes])
      this.$emit('update:totalHours', this.totalHours)
    },
    getHoursText(hours) {
      const lastDigit = hours % 10
      const lastTwoDigits = hours % 100
      
      if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'часов'
      }
      
      if (lastDigit === 1) {
        return 'час'
      }
      
      if (lastDigit >= 2 && lastDigit <= 4) {
        return 'часа'
      }
      
      return 'часов'
    }
  }
}
</script>

<template>
  <div class="time-picker">
    <div class="time-picker__header">
      <p class="time-picker__subtitle">
        Оптимальное количество сна для физического и психического здоровья – {{ optimalHoursText }} {{ getHoursText(optimalHoursText) }}.
      </p>
      <div v-if="totalHours > 0" class="time-picker__stats">
        <p class="time-picker__total" :class="'time-picker__total--' + sleepDurationStatus">
             {{ totalHours }} {{ getHoursText(totalHours) }}
        </p>
        <div class="time-picker__distribution">
          <span>Вы спали сегодня:</span> <span>{{ nightHours }} {{ getHoursText(nightHours) }} ночью • {{ dayHours }} {{ getHoursText(dayHours) }} днем</span>
        </div>
      </div>
    </div>
    
    <div class="time-picker__grid">
      <div v-for="(block, blockIndex) in timeBlocks" :key="blockIndex" class="time-picker__block">
        <button
          v-for="time in block"
          :key="time"
          class="time-picker__time-btn"
          :class="{ 'time-picker__time-btn--selected': isSelected(time) }"
          @click="selectTime(time)"
          type="button"
        >
          <span>{{ time }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.time-picker {
 
  &__header {
    margin-bottom: 24px;
  }

  &__title {
    font-size: 24px;
    margin: 0 0 8px 0;
    font-weight: 600;
    color: #1a1a1a;
  }

  &__subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
    line-height: 1.4;
  }

  &__stats {
    margin-top: 12px;
    padding-top: 12px;
  }

  &__total {
    font-size: 36px;
    font-weight: 600;
    margin: 0 0 8px 0;
      padding-bottom: 8px;
      border-bottom: 1px solid #eee;
      line-height: 1;

    &--optimal {
      color: #4CAF50;
    }

    &--tooMuch {
      color: #FF9800;
    }

    &--low {
      color: #FF9800;
    }

    &--critical {
      color: #F44336;
    }
  }

  &__distribution {
    font-size: 14px;
    color: #666;
    margin: 0;
      display: flex;
      justify-content: space-between;
  }

  &__grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__block {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }

  &__time-btn {
      background: none;
    border: 1px solid #D9D9D9;

      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #1a1a1a;

    &:hover {
      background: #eee;
    }

    &--selected {
      background: #F5EEE8;
      color: #000000;
      border-color: #F5EEE8;

      &:hover {
        background: #F5EEE8;
          color: #000000;
          border-color: #F5EEE8;
      }
    }
  }
}
</style>